import { meLoad } from './meLoad.setup'
import { balanceLoad } from './balance.setup'
import { countersLoad } from './counters.setup'

export async function loadAll() {
  return await Promise.all([meLoad(), balanceLoad(), countersLoad()])
}
